import {
  START_SEARCH,
  RECEIVE_SEARCH_RESULTS,
  CLEAR_SEARCH_RESULTS,
  SEARCH_FAILED

} from '../actions/types';

export const mainSearchRequest = (state = {}, action) => {
  switch (action.type) {
    case START_SEARCH:
      return Object.assign({}, state, {
        isFetching: true,
        results: state.results || {},
        error: null
      });
    case RECEIVE_SEARCH_RESULTS:
      return Object.assign({}, state, {
        isFetching: false,
        results: action.results,
        error: null
      });
    case SEARCH_FAILED:
      return Object.assign({}, state, {
        isFetching: false,
        results: state.results || {},
        error: action.error
      });

    case CLEAR_SEARCH_RESULTS:
      return Object.assign({}, state, {
        isFetching: false,
        results: [],
        error: null
      });

    default:
      return state;
  }
};
